import React from 'react';
import styles from './index.module.scss';

export default function Screen3() {
  return (
    <section className={styles['screen3-cover']}>
      <div className={styles['screen3-wrap']}>
        <div className={styles['screen3-photo']}></div>
        <div className={styles['screen3-back']}></div>
        <div className={styles['screen3-content']}>
          <div className={styles['screen3-text']}>
            <div className={styles['screen3-title']}>我们的团队</div>
            <div className={styles['screen3-desc']}>
            我们的核心团队汇聚了来自全球企业的杰出人才，他们曾在苹果、字节跳动、拼多多、阿里巴巴、百度、京东、腾讯、快手、高途、猿辅导、好未来、Vipkid、美团、搜狗、滴滴等知名企业担任关键岗位。我们的成员不仅拥有来自北京大学、清华大学、中国人民大学、复旦大学、香港理工大学、剑桥大学、卡耐基梅隆大学、新加坡国立大学等世界知名学府的深厚学术背景，还曾荣获 iF 设计奖、吴文俊人工智能最高奖等荣誉奖项，彰显了他们在各自领域的卓越成就。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
